// extracted by mini-css-extract-plugin
export default {"telia-logo":"LoggedOut_telia-logo__ki2jq"};